import React from "react";
import {Card} from "../../../../../components/card/card.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";

const POLICE_OPTIONS = ["flagrant", "infracionalAct", "indicted", "notCriminal"];

const DispatchClosure = ({
    flags,
    setFlag,
    providence,
    onProvidenceChange,
    providenceOptions,
    finalObservation,
    onFinalObservationChange,
    isSupport,
    showCancelSupport,
}) => {
    const onNotFound = (checked) => {
        if (checked) {
            setFlag({notFound: true, publicPatrimony: false, policeAuthority: false, flagrant: false, infracionalAct: false, indicted: false, notCriminal: false});
        } else {
            setFlag({notFound: false});
        }
    };

    const onPublicPatrimony = (checked) =>
        setFlag(checked ? {publicPatrimony: true, notFound: false} : {publicPatrimony: false});

    const onPoliceAuthority = (checked) => {
        if (!checked) {
            setFlag({policeAuthority: false, flagrant: false, infracionalAct: false, indicted: false, notCriminal: false});
        } else {
            setFlag({policeAuthority: true, notFound: false});
        }
    };

    const onOption = (field, checked) => {
        const next = {...flags, [field]: checked};
        const anyChecked = POLICE_OPTIONS.some(option => next[option]);
        setFlag({
            [field]: checked,
            policeAuthority: anyChecked,
            ...(anyChecked ? {notFound: false} : {}),
        });
    };

    const providenceValue = providenceOptions.find(option => option.value === providence) ?? null;

    return (
        <Card>
            <Card.Header>
                <Card.Title>Encerramento</Card.Title>
            </Card.Header>
            <Card.Body className="flex flex-col gap-4">
                <SentryRow>
                    <div className="col-span-3 flex flex-col gap-3">
                        <InputCheckbox
                            id="notFound"
                            label="Não constatado"
                            checked={flags.notFound}
                            disabled={isSupport}
                            onChange={({target}) => onNotFound(target.checked)}
                        />
                        <InputCheckbox
                            id="publicPatrimony"
                            label="Patrimônio público"
                            checked={flags.publicPatrimony}
                            disabled={isSupport}
                            onChange={({target}) => onPublicPatrimony(target.checked)}
                        />
                    </div>

                    <div className="col-span-6 flex flex-col gap-3">
                        <InputCheckbox
                            id="policeAuthority"
                            label="Autoridade policial?"
                            checked={flags.policeAuthority}
                            disabled={isSupport}
                            onChange={({target}) => onPoliceAuthority(target.checked)}
                        />
                        <div className="flex flex-wrap gap-4">
                            <InputCheckbox id="flagrant" label="Flagrante" checked={flags.flagrant} disabled={isSupport} onChange={({target}) => onOption("flagrant", target.checked)}/>
                            <InputCheckbox id="infracionalAct" label="Ato infracional" checked={flags.infracionalAct} disabled={isSupport} onChange={({target}) => onOption("infracionalAct", target.checked)}/>
                            <InputCheckbox id="indicted" label="Indiciado" checked={flags.indicted} disabled={isSupport} onChange={({target}) => onOption("indicted", target.checked)}/>
                            <InputCheckbox id="notCriminal" label="Não criminal" checked={flags.notCriminal} disabled={isSupport} onChange={({target}) => onOption("notCriminal", target.checked)}/>
                        </div>
                    </div>

                    {showCancelSupport &&
                        <div className="col-span-3">
                            <InputCheckbox
                                id="cancelSupport"
                                label="Cancelar apoio"
                                checked={flags.cancelSupport}
                                onChange={({target}) => setFlag({cancelSupport: target.checked})}
                            />
                        </div>
                    }
                </SentryRow>

                <SelectComponent
                    classNameWrapper="col-span-12"
                    id="providence"
                    label="Providência"
                    options={providenceOptions}
                    value={providenceValue}
                    isDisabled={isSupport}
                    onChange={(option) => onProvidenceChange(option?.value ?? "")}
                />

                <InputTextarea
                    id="finalObservation"
                    label="Observação final"
                    textAreaClass="h-25!"
                    value={finalObservation}
                    onChange={({target: {value}}) => onFinalObservationChange(value)}
                />
            </Card.Body>
        </Card>
    );
};

export default DispatchClosure;
